import React from 'react';
import { Box, alpha, type Theme } from '@mui/material';

export interface Sparkle {
  id: number;
  x: number;
  y: number;
  size: number;
  opacity: number;
  duration: number;
  delay: number;
}

export function createSparkles(count: number): Sparkle[] {
  return Array.from({ length: count }).map((_, index) => ({
    id: index,
    x: Math.random() * 100,
    y: Math.random() * 100,
    size: 2 + Math.random() * 5,
    opacity: 0.3 + Math.random() * 0.7,
    duration: 2 + Math.random() * 4,
    delay: Math.random() * 3,
  }));
}

export function BetaSparkleBackground({
  sparkles,
  theme,
}: {
  sparkles: Sparkle[];
  theme: Theme;
}): React.ReactElement {
  return (
    <Box
      sx={{
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        zIndex: 0,
        overflow: 'hidden',
      }}
    >
      {sparkles.map(sparkle => (
        <Box
          key={sparkle.id}
          sx={{
            position: 'absolute',
            left: `${sparkle.x}%`,
            top: `${sparkle.y}%`,
            width: sparkle.size,
            height: sparkle.size,
            borderRadius: '50%',
            bgcolor: alpha(theme.palette.primary.main, sparkle.opacity),
            boxShadow: `0 0 ${sparkle.size * 2}px ${alpha(
              theme.palette.primary.main,
              sparkle.opacity
            )}`,
            animation: `float ${sparkle.duration}s ease-in-out ${sparkle.delay}s infinite alternate`,
          }}
        />
      ))}
    </Box>
  );
}
